<template>
  <jd-dialog
    v-bind="dialogProps"
    :center="true"
    :show-close="false"
    :custom-class="['result-dialog', dialogProps.customClass].join(' ')"
    modal-class="result-dialog"
  >
    <jd-result v-bind="resultProps">
      <template v-if="slots.icon" #icon>
        <slot name="icon" />
      </template>
      <template v-if="slots.extra" #extra>
        <slot name="extra" />
      </template>
    </jd-result>
  </jd-dialog>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue'
import JdDialog from '../../dialog/src/dialog.vue'
import JdResult from './result.vue'

import { resultDialogProps } from './result-dialog'

defineOptions({
  name: 'JdResultDialog',
})

defineProps(resultDialogProps)

const slots = useSlots()
</script>
